import { Files } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const FilesIcon = DeckardIconWrapper({ Icon: Files });
